import React from 'react'

type Props = {
    className?: string
}

export const RotateIcon = (props: Props) => {
    const { className = 'w-5 h-5' } = props

    return (
        <svg fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24" className={className}>
            <path d="M12 5H6a2 2 0 0 0-2 2v3"/>
            <path d="m9 8 3-3-3-3"/>
            <path d="M4 14v4a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2"/>
        </svg>
    )
}
